import React, { useState, useEffect, useRef } from "react";
import Job from "../common/job/Job";
import { Link } from "react-router-dom";
import "./jobs.css";
import queryString from "query-string";
import axios from "axios";
import Header from "../common/header/Header";
import Footer from "../home/footer/Footer";
import jobsConfig from "../../configs/jobDepartments/jobDepartments.json";
import Config from "../../configs";
import { isMobile, getBrandLogoUrl } from "../../utils";

const baseUrl = `${Config.gatewayBaseUrl}/api/v2/platform-gateway`;

const Jobs = ({ location }) => {
  const [filter, setFilter] = useState({
    departments: [],
    specialisation: [],
    locations: [],
    searchKey: "",
  });
  const [jobsList, setJobsList] = useState([]);
  const [allJobsList, setAllJobsList] = useState([]);
  const ucDepartments = jobsConfig.parentDepartmentInUc;
  const [ucLocations, setUcLocations] = useState([]);
  const topRef = useRef();
  
  const handleObserver = (entities, observer) => {
    const isVisible = entities[0].isIntersecting;
    if (!isVisible) {
      document.querySelector(".uc-navbar-wrapper").classList.add("white-header");
      document.querySelector("#uc-logo").src = getBrandLogoUrl('white');
    } else {
      document.querySelector(".uc-navbar-wrapper").classList.remove("white-header");
      document.querySelector("#uc-logo").src = getBrandLogoUrl('dark');
    }
  }

  const options = {
    rootMargin: "-64px 0px 0px 0px",
    threshold: 0 // Only observe when the entire box is in view
  }
  const observer = new IntersectionObserver(
    handleObserver, //callback
    options
  );

  useEffect(() => {
    // Create an observer
    //Observ the `ref`
    if(!isMobile()){
      observer.observe(topRef.current);
    }
  }, [])
  
  useEffect(() => {
    window.scrollTo(0, 0);
    let { department, specialisation } = queryString.parse(location.search);
    if (department) {
      let child_departments =
        jobsConfig.departmentInCareerPage__parentDepartmentInUc[
          department
        ] || [];

      const textFilters = [];
      if(specialisation) {
        child_departments.forEach((dept) => {
          if(jobsConfig.department__specialisation[dept] && jobsConfig.department__specialisation[dept].indexOf(specialisation) !== -1) {
            textFilters.push(...(jobsConfig.specialisation__filters[specialisation] || []));
          }
        })
      }
      setFilter({
        ...filter,
        departments: child_departments ? child_departments : [],
        specialisation: textFilters,
      });
    }
  }, []);

  useEffect(() => {
    axios.post(`${baseUrl}/getAllJobs`).then((response) => {
      setJobsList(response.data.jobs);
      setAllJobsList(response.data.jobs);
    });
  }, []);

  useEffect(() => {
    applyFilter(
      filter.departments,
      filter.locations,
      filter.searchKey,
      allJobsList,
      filter.specialisation
    );

    let locationsFromJobs = [];
    let departmentsFromJobs = [];
    allJobsList.map((job) => {
      if (!departmentsFromJobs.includes(job.parent_department)) {
        departmentsFromJobs.push(job.parent_department);
      }
      job.location_city.map((city) => {
        if (city.length && !locationsFromJobs.includes(city)) {
          locationsFromJobs.push(city);
        }
      });
      return;
    });

    setUcLocations(locationsFromJobs);

    if (departmentsFromJobs.length === 0) return;

    departmentsFromJobs.map((department) => {
      if (!ucDepartments.includes(department)) {
        console.log(`NEW: ${department}`);
      }
    });
    ucDepartments.map((department) => {
      if (!departmentsFromJobs.includes(department)) {
        console.log(`Missing: ${department}`);
      }
    });
  }, [allJobsList]);

  const checkForDepartment = (job, departments) => {
    if (
      departments.length === 0 ||
      departments.includes(job.parent_department)
    ) {
      return true;
    }
    return false;
  };
  const checkForLocation = (job, locations) => {
    if (
      locations.length === 0 ||
      job.location_city.some((location) => locations.includes(location))
    ) {
      return true;
    }
    return false;
  };
  const checkForSearchKey = (job, searchKey) => {
    if (
      !searchKey ||
      searchKey === "" ||
      job.job_title.toLowerCase().includes(searchKey.toLowerCase())
    ) {
      return true;
    }
    return false;
  };
  const checkForSpecialisation = (job, specialisation) => {
    if (specialisation.length === 0 || 
      specialisation.some((text) => checkForSearchKey(job, text))
    ) {
      return true;
    }
    return false;
  };
  const applyFilter = (departments, locations, searchKey, allJobsList, specialisation = []) => {
    let filteredJobsList = allJobsList.filter((job) => {
      if (
        checkForDepartment(job, departments) &&
        checkForLocation(job, locations) &&
        checkForSearchKey(job, searchKey) &&
        checkForSpecialisation(job, specialisation)
      ) {
        return true;
      } else {
        return false;
      }
    });
    setJobsList(filteredJobsList);
  };
  const handleDepartmentChange = (event) => {
    let newDepartments = [];
    if (filter.departments.includes(event.target.value)) {
      newDepartments = filter.departments.filter(
        (department) => department !== event.target.value
      );
    } else {
      newDepartments = filter.departments.concat(event.target.value);
    }
    setFilter({
      ...filter,
      departments: newDepartments,
    });
    applyFilter(
      newDepartments,
      filter.locations,
      filter.searchKey,
      allJobsList
    );
  };
  const handleLocationChange = (event) => {
    let newLocations = [];
    if (filter.locations.includes(event.target.value)) {
      newLocations = filter.locations.filter(
        (location) => location !== event.target.value
      );
    } else {
      newLocations = filter.locations.concat(event.target.value);
    }
    setFilter({
      ...filter,
      locations: newLocations,
    });
    applyFilter(
      filter.departments,
      newLocations,
      filter.searchKey,
      allJobsList
    );
  };
  const handleSearchChange = (event) => {
    setFilter({
      ...filter,
      searchKey: event.target.value,
    });
    applyFilter(
      filter.departments,
      filter.locations,
      event.target.value,
      allJobsList
    );
  };
  const dropDown = (key) => (event) => {
    document.getElementById(key).classList.remove("d-none");
    document.getElementById("overlay").classList.remove("d-none");
  };
  const hide = (event) => {
    let items = document.getElementsByClassName("menu");
    for (let i = 0; i < items.length; i++) {
      items[i].classList.add("d-none");
    }
    document.getElementById("overlay").classList.add("d-none");
  };
  const removeDepartmentFilter = (target) => (event) => {
    let newDepartments = filter.departments.filter(
      (department) => department !== target
    );
    setFilter({
      ...filter,
      departments: newDepartments,
    });
    applyFilter(
      newDepartments,
      filter.locations,
      filter.searchKey,
      allJobsList
    );
  };
  const removeLocationFilter = (target) => (event) => {
    let newLocations = filter.locations.filter(
      (location) => location !== target
    );
    setFilter({
      ...filter,
      locations: newLocations,
    });
    applyFilter(
      filter.departments,
      newLocations,
      filter.searchKey,
      allJobsList
    );
  };
  return (
    <div className="jobs">
      <Header />
      <div className="header" ref={topRef}>
        <div className="heading">
          <h1>Open positions</h1>
        </div>
      </div>
      <div className="body">
        <div className="filter-box">
          <div className="filter-inputs">
            <div style={{ width: 0 }}>
              <i className="fa fa-search search-icon" aria-hidden="true"></i>
            </div>
            <input
              type="text"
              placeholder="Search by role"
              className="filter filter-role"
              value={filter.searchKey}
              onChange={handleSearchChange}
            />
            <div className="filter filter-department filter-dropdown">
              <div
                onClick={dropDown("departments-drop-menu")}
                className="menu-btn"
              >
                <div className="drop-header">All departments</div>
                <div className="drop-arrow">&nbsp; &#9013;</div>
              </div>
              <div
                className="d-none shadow rounded menu"
                id="departments-drop-menu"
              >
                {ucDepartments.map((department, index) => {
                  return (
                    <span key={index} className="d-block menu-option">
                      <label>
                        <input
                          type="checkbox"
                          onChange={handleDepartmentChange}
                          value={department}
                          checked={
                            filter.departments
                              ? filter.departments.includes(department)
                              : false
                          }
                        />
                        &nbsp; {department}
                      </label>
                    </span>
                  );
                })}
              </div>
            </div>
            <div className="filter filter-location filter-dropdown">
              <div
                onClick={dropDown("locations-drop-menu")}
                className="menu-btn"
              >
                <div className="drop-header">All locations</div>
                <div className="drop-arrow">&nbsp; &#9013;</div>
              </div>
              <div
                className="d-none shadow rounded menu"
                id="locations-drop-menu"
              >
                {ucLocations.map((location, index) => {
                  return (
                    <span key={index} className="d-block menu-option">
                      <label>
                        <input
                          type="checkbox"
                          onChange={handleLocationChange}
                          value={location}
                          checked={
                            filter.locations
                              ? filter.locations.includes(location)
                              : false
                          }
                        />
                        &nbsp; {location}
                      </label>
                    </span>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="d-none" id="overlay" onClick={hide}></div>
          <div className="filter-message">
            <div className="text">
              {jobsList ? jobsList.length : undefined} openings
            </div>
            <div className="filter-pills">
              {filter.departments
                ? filter.departments.map((name, index) => {
                    return (
                      <div key={index} className="filter-pill">
                        {name} &nbsp;{" "}
                        <span onClick={removeDepartmentFilter(name)}>
                          &#x2715;
                        </span>
                      </div>
                    );
                  })
                : undefined}
              {filter.locations
                ? filter.locations.map((name, index) => {
                    return (
                      <div
                        key={index}
                        className="filter-pill"
                        onClick={removeLocationFilter(name)}
                      >
                        {name} &nbsp;{" "}
                        <span onClick={removeLocationFilter(name)}>
                          &#x2715;
                        </span>
                      </div>
                    );
                  })
                : undefined}
            </div>
          </div>
        </div>
        <div className="jobs-list">
          <div className="row list-header">
            <div className="col col-6">Job title</div>
            <div className="info-header col col-6">
              <div className="department-header">Department</div>
              <div className="location-header">Location</div>
            </div>
          </div>
          <div className="list-body">
            {jobsList
              ? jobsList.map((job, index) => (
                  <Link key={index} to={`/jobDetail?id=${job.job_id}`}>
                    <Job
                      key={index}
                      role={job.job_title}
                      department={job.parent_department}
                      locations={job.location_city}
                    />
                  </Link>
                ))
              : undefined}
          </div>
        </div>
        <div className="contact-us">
            Can't find a suitable role? Share your resume with us at <a style={{ color: "#007bff"}} href="mailto:careers@urbancompany.com">careers@urbancompany.com</a>.
          </div>
      </div>
      <Footer />
    </div>
  );
};

export default Jobs;
